import axios from "axios";
import api from "../config/api-config";

export const getDataForCalendar = (payload) => {
  return axios.post(
    `${api.host}/TCTarif/disponibiliteTarif`,
    payload
  );
};